<template>
    <div>
        <div class="panel-icon" id='icon-container' :class="{start_animation:!showPanel}">
            <img src="assets/handsShake.jpg" id="icon" alt="shaek-hands-logo" 
            @click="togglePanelMethod">
        </div>
    </div>
</template>



<script>
import { mapState,mapActions } from 'vuex';
export default {
    data:function(){
        return{

        }
    },
    computed:{
        ...mapState('notifications',['showPanel'])
    },
    methods:{
        ...mapActions('notifications',['togglePanel']),
        togglePanelMethod(){
            this.togglePanel()
        }
    },
  
}
</script>

<style lang="scss" scoped>
 
    .panel-icon{
      
        &.start_animation{
               
            &>#icon{
               width: 40px;
               height: 48px;
               transform:translate(10px,20px);
               transition: all .4s ease-in-out;
            }
        }
        
    }        
    #icon{
        width:78px;
        height: 82px;
        border-radius:50%;
        cursor: pointer;
        transition: all .4s ease-in-out;
    }
    
</style>
